import { atom } from 'jotai';
import { ITenant } from '../services/tenantService';

export const tenantAtom = atom<ITenant | undefined>(undefined);

export const tenantInfoAtom = atom<any>((get) => {
  const otherInfo = get(tenantAtom)?.otherInfo;
  return otherInfo ? otherInfo : undefined;
});

export function hasCodeConventionFormat(
  tenantInfo: any,
  key:
    | 'asset-code-convention'
    | 'order-code-convention'
    | 'work-code-convention'
): boolean {
  try {
    const info =
      typeof tenantInfo === 'string' ? JSON.parse(tenantInfo) : tenantInfo;
    return !!info?.[key]?.format;
  } catch {
    return false;
  }
}
